import { render, staticRenderFns } from "./OrderPayResult.vue?vue&type=template&id=4d6c07c0&"
import script from "./OrderPayResult.vue?vue&type=script&lang=js&"
export * from "./OrderPayResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports